import React from "react";
import { groupIndianInput, shortINRHint } from "../../lib/currency";

// Amount input with live Indian-style grouping (20,00,000) and a short-form
// hint below it (₹20 L / ₹2 Cr / ₹20 K). Emits the raw, comma-free numeric
// string via onValueChange so existing `Number(value)` parsing keeps working.
export default function MoneyInput({
  value,
  onValueChange,
  hint = true,
  className = "",
  hintClassName = "",
  ...rest
}) {
  const raw = value === null || value === undefined ? "" : String(value);

  const handleChange = (e) => {
    const next = e.target.value.replace(/,/g, "");
    if (/^\d*\.?\d*$/.test(next)) {
      onValueChange(next);
    }
  };

  const hintText = hint ? shortINRHint(raw) : "";

  return (
    <>
      <input
        type="text"
        inputMode="decimal"
        value={groupIndianInput(raw)}
        onChange={handleChange}
        className={`input-soft ${className}`}
        {...rest}
      />
      {hintText && (
        <p
          className={`mt-1 text-[11px] font-semibold text-emerald-600 dark:text-emerald-400 ${hintClassName}`}
        >
          {hintText}
        </p>
      )}
    </>
  );
}
